import { AuthContext } from '@repo-level/core-front';
import { findGroup } from 'helpers/cms';
import { USER_GROUP } from 'helpers/user';
import { useContext, useMemo } from 'react';

export const useIsLibergos = () => {
  const { user } = useContext(AuthContext);

  const isLibergos = useMemo(() => {
    if (!user?.statuses) return;

    return findGroup(user.statuses)(USER_GROUP.LIBERGOS);
  }, [user?.statuses]);

  return isLibergos;
};
